/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Height (cm)`)
};

const es_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (cm)`)
};

const de_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe (cm)`)
};

const nl_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengte (cm)`)
};

const fr_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille (cm)`)
};

const it_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza (cm)`)
};

const pt_br2_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (cm)`)
};

const pt_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura (cm)`)
};

const ja_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身長 (cm)`)
};

const zh_h_height_cm = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身高（厘米）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const h_height_cm = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.h_height_cm(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("h_height_cm", locale)
	if (locale === "en") return en_h_height_cm(inputs)
	if (locale === "es") return es_h_height_cm(inputs)
	if (locale === "de") return de_h_height_cm(inputs)
	if (locale === "nl") return nl_h_height_cm(inputs)
	if (locale === "fr") return fr_h_height_cm(inputs)
	if (locale === "it") return it_h_height_cm(inputs)
	if (locale === "pt-BR") return pt_br2_h_height_cm(inputs)
	if (locale === "pt") return pt_h_height_cm(inputs)
	if (locale === "ja") return ja_h_height_cm(inputs)
	return zh_h_height_cm(inputs)
};